import { Model } from './model'
import { Entity } from './entity.model'

export class User extends Model {
  email: string
  name: string
  role: string
  suite: string
  suiteId: string;
  avatarUrl: string
  entities: Entity[]

  constructor(obj = {}) {
    super(obj)
    this.entities = (obj['entities'] || []).map(entity => new Entity(entity))
  }
}
